import * as React from "react";
import Typography from '@material-ui/core/Typography';


const Text=(props)=>{
    const {className,children,variant,...rest}=props
    return(
        <Typography variant={variant} fontWeight={700} className={ className} {...rest}>
            {children}
        </Typography>
    )
}
export default Text;